import stock from './stock'
import sales from './sales'
import order from './order'
import warehouse from './warehouse'
import account from './account'
import logisticscompany from './logisticscompany'
import stockCheck from './stockCheck'

export default {
  ims: {
    ...stock,
    ...order,
    ...sales,
    ...warehouse,
    ...account,
    ...logisticscompany,
    ...stockCheck
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/ims/ims.js